var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"id":_vm.id},domProps:{"value":_vm.value},on:{"input":_vm.setValue}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option[1]}},[_vm._v(_vm._s(option[0]))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }